import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { SessionContextProvider } from './providers';

import './common/i18n.config';

import App from './components/app/app.component';

ReactDOM.render(
  <BrowserRouter>
    <SessionContextProvider>
      <App />
    </SessionContextProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
